import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/assets/i18n'
import statisticsRouter from './router.statistics'
import systemRouter from './router.system'
import teacherRouter from './router.teacher'
import studentRouter from './router.student'
import login from '@/pages/Login/Login'
import hrlogin from '@/pages/Login/HRLogin'

const config = require('@/config');
import {Storage} from '@/utils';

Vue.use(Router);

const routes = [
    // 公共路由写在这里，其他抽离
    {
        path: '/',
        redirect: to => {
            return {name: 'login'}
        },
    }, {
        path: '*',
        redirect: '/'
    }, {
        path: '/login',
        name: 'login',
        component: login,
        meta: {single: true},
    }, {
        path: '/hrlogin',
        name: 'hrlogin',
        component: hrlogin,
        meta: {single: true},
    },
    {
        path: '/authentication',
        name: 'authentication',
        component: () => import('@/pages/Authentication/Index'),
    },
    {
        path: '/test/sentry',
        name: 'sentryTest',
        component: () => import('@/pages/Test/SentryTest'),
    },

    // 统计路由
    ...statisticsRouter,

    // system
    ...systemRouter,

    // student
    ...studentRouter,

    // teacher
    ...teacherRouter,
]

const router = new Router({
    // history 模式，需要服务器后端配合做路由代理，将所有的前端路由同步代理到 /
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return {
            x: 0,
            y: 0
        };
    },
    routes
})

// 动态赋值 document.title
router.beforeEach((to, from, next) => {
    const menuData = Storage.get('menu')
    if (menuData) {
        let matchedTitle = config.appName

        if (to?.meta?.title) {
            matchedTitle = to.meta.title
        } else {
            menuData.forEach(item => {
                if (item.path === to.path) {
                    matchedTitle = item.name
                } else if (item.children.length) {
                    let matched = item.children.find(v => v.path === to.path)
                    if (matched) {
                        matchedTitle = matched.name
                    }
                }
            })
        }

        document.title = matchedTitle
    }

    next()
})

export default router
